import Model from '@/class/cargo/model/utils/Model'

export class CargoSource {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'CargoSource'

export const NC_CARGO_SOURCE = new CargoSource('NC', 'Nominated Cargo', '指定货')
// export const PC_CARGO_SOURCE = new CargoSource("PC", "Peer Cargo", "同行货");
export const SC_CARGO_SOURCE = new CargoSource('SC', 'Free Hand', '自揽货')// 销售揽货

export const CARGO_SOURCES = [NC_CARGO_SOURCE, SC_CARGO_SOURCE]// PC_CARGO_SOURCE,

export const CARGO_SOURCE_CODES = new Set(['NC', 'SC'])

/**
		 *  return null:没找到.
		 */
export function getCargoSourceByCode(code) {
  return Model.getObjByCode(code, CARGO_SOURCES)
}

export function getStateIndexByCode(code) {
  var index = -1
  for (let i = 0; i < CARGO_SOURCES.length; i++) {
    const state = CARGO_SOURCES[i]
    if (state.code === code) {
      index = i
      break
    }
  }
  return index
}

